// Утилиты для генерации Schema.org разметки для Яндекс

let schemaScripts = []

export function addSchemaScript(schema, id = null) {
  if (!schema) return

  // Если указан ID, удаляем старый скрипт с таким ID
  if (id) {
    const existingScript = document.querySelector(`script[data-schema-id="${id}"]`)
    if (existingScript) {
      existingScript.remove()
      schemaScripts = schemaScripts.filter(s => s.id !== id)
    }
  }

  // Создаем новый скрипт
  const script = document.createElement('script')
  script.type = 'application/ld+json'
  script.textContent = JSON.stringify(schema)
  if (id) {
    script.setAttribute('data-schema-id', id)
  }
  document.head.appendChild(script)
  
  if (id) {
    schemaScripts.push({ id, script })
  }
}

export function clearAllSchemas() {
  document.querySelectorAll('script[type="application/ld+json"]').forEach(script => {
    script.remove()
  })
  schemaScripts = []
}

export function getOrganizationSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'Мама я в Китае',
    url: window.location.origin,
    logo: window.location.origin + '/logo.png',
    description: 'Онлайн школа китайского языка. Изучение китайского языка онлайн с лучшими преподавателями.',
    address: {
      '@type': 'PostalAddress',
      addressCountry: 'RU'
    },
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'customer service',
      availableLanguage: ['Russian']
    },
    sameAs: []
  }
}

export function getWebSiteSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'Мама я в Китае',
    url: window.location.origin,
    description: 'Онлайн школа китайского языка. Изучение китайского языка онлайн с лучшими преподавателями.',
    potentialAction: {
      '@type': 'SearchAction',
      target: {
        '@type': 'EntryPoint',
        urlTemplate: window.location.origin + '/search?q={search_term_string}'
      },
      'query-input': 'required name=search_term_string'
    }
  }
}

export function getCourseSchema(course) {
  if (!course) return null

  const schema = {
    '@context': 'https://schema.org',
    '@type': 'Course',
    name: course.name,
    description: course.description?.html ? 
      course.description.html.replace(/<[^>]*>/g, '').substring(0, 500) : 
      `Курс китайского языка: ${course.name}`,
    provider: {
      '@type': 'Organization',
      name: 'Мама я в Китае',
      url: window.location.origin
    },
    url: window.location.href,
    courseCode: course.slug || course.id?.toString()
  }

  if (course.price && !course.is_free) {
    schema.offers = {
      '@type': 'Offer',
      price: course.price,
      priceCurrency: 'RUB',
      availability: 'https://schema.org/InStock'
    }
  }

  if (course.photo) {
    schema.image = course.photo
  }

  return schema
}

export function getPersonSchema(teacher) {
  if (!teacher) return null

  const schema = {
    '@context': 'https://schema.org',
    '@type': 'Person',
    name: `${teacher.first_name || ''} ${teacher.last_name || ''}`.trim() || teacher.name,
    jobTitle: 'Преподаватель китайского языка',
    worksFor: {
      '@type': 'Organization',
      name: 'Мама я в Китае',
      url: window.location.origin
    },
    url: window.location.href
  }

  if (teacher.photo) {
    schema.image = teacher.photo
  }

  if (teacher.bio) {
    schema.description = teacher.bio.substring(0, 500)
  }

  return schema
}

export function getBreadcrumbSchema(items) {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.name,
      item: item.url
    }))
  }
}
